import { useEffect, useState } from "react";

type LocationType = {
  latitude: number;
  longitude: number;
};

export const useGeoLocation = () => {
  // const [location, setLocation] = useState<LocationType | null>(null);
  // const [error, setError] = useState<boolean>(true);
  // const [loading, setLoading] = useState<boolean>(false);

  const { language } = navigator;
  // const region = new Intl.Locale(language).region || 'KR';
  const region = "KR";
  const location = GeoMap[region.toLowerCase()];
  // useEffect(() => {
  //   setLocation(location);
  // }, []);

  return { location };
};

const GeoMap = {
  af: { latitude: -30.5595, longitude: 22.9375 },
  al: { latitude: 41.1533, longitude: 20.1683 },
  dz: { latitude: 28.0339, longitude: 1.6596 },
  as: { latitude: -14.2709, longitude: -170.1322 },
  ad: { latitude: 42.5463, longitude: 1.6016 },
  ao: { latitude: -11.2027, longitude: 17.8739 },
  ai: { latitude: 18.2206, longitude: -63.0686 },
  ag: { latitude: 17.0608, longitude: -61.7964 },
  ar: { latitude: -38.4161, longitude: -63.6167 },
  am: { latitude: 40.0691, longitude: 45.0382 },
  aw: { latitude: 12.5211, longitude: -69.9683 },
  au: { latitude: -25.2744, longitude: 133.7751 },
  at: { latitude: 47.5162, longitude: 14.5501 },
  az: { latitude: 40.1431, longitude: 47.5769 },
  bh: { latitude: 25.9304, longitude: 50.6378 },
  bd: { latitude: 23.685, longitude: 90.3563 },
  bb: { latitude: 13.1939, longitude: -59.5432 },
  by: { latitude: 53.7098, longitude: 27.9534 },
  be: { latitude: 50.5039, longitude: 4.4699 },
  bz: { latitude: 17.1899, longitude: -88.4976 },
  bj: { latitude: 9.3077, longitude: 2.3158 },
  bm: { latitude: 32.3078, longitude: -64.7505 },
  bt: { latitude: 27.5142, longitude: 90.4336 },
  bo: { latitude: -16.2902, longitude: -63.5887 },
  bq: { latitude: 12.1784, longitude: -68.2385 },
  ba: { latitude: 43.9159, longitude: 17.6791 },
  bw: { latitude: -22.3285, longitude: 24.6849 },
  br: { latitude: -14.235, longitude: -51.9253 },
  io: { latitude: -6.3432, longitude: 71.8765 },
  vg: { latitude: 18.4207, longitude: -64.6396 },
  bn: { latitude: 4.5353, longitude: 114.7277 },
  bg: { latitude: 42.7339, longitude: 25.4858 },
  bf: { latitude: 12.2383, longitude: -1.5616 },
  bi: { latitude: -3.3731, longitude: 29.9189 },
  kh: { latitude: 11.55, longitude: 104.9167 },
  cm: { latitude: 7.3697, longitude: 12.3547 },
  ca: { latitude: 56.1304, longitude: -106.3468 },
  cv: { latitude: 16.5388, longitude: -23.0418 },
  ky: { latitude: 19.3133, longitude: -81.2546 },
  cf: { latitude: 6.6111, longitude: 20.9394 },
  td: { latitude: 15.4542, longitude: 18.7322 },
  cl: { latitude: -35.6751, longitude: -71.543 },
  cn: { latitude: 35.8617, longitude: 104.1954 },
  cx: { latitude: -10.4475, longitude: 105.6903 },
  cc: { latitude: -12.1642, longitude: 96.8706 },
  co: { latitude: 4.5709, longitude: -74.2973 },
  km: { latitude: -11.875, longitude: 43.8722 },
  cg: { latitude: -0.228, longitude: 15.8277 },
  cd: { latitude: -4.0383, longitude: 21.7587 },
  ck: { latitude: -21.2367, longitude: -159.7776 },
  cr: { latitude: 9.7489, longitude: -83.7534 },
  hr: { latitude: 45.1, longitude: 15.2 },
  cu: { latitude: 21.5218, longitude: -77.7812 },
  cw: { latitude: 12.1696, longitude: -68.99 },
  cy: { latitude: 35.1264, longitude: 33.4299 },
  cz: { latitude: 49.8175, longitude: 15.473 },
  dk: { latitude: 56.2639, longitude: 9.5018 },
  dj: { latitude: 11.8251, longitude: 42.5903 },
  dm: { latitude: 15.414, longitude: -61.370976 },
  do: { latitude: 18.7357, longitude: -70.1627 },
  ec: { latitude: -1.8312, longitude: -78.1834 },
  eg: { latitude: 26.820553, longitude: 30.802498 },
  sv: { latitude: 13.794185, longitude: -88.89653 },
  gq: { latitude: 1.650801, longitude: 10.267895 },
  er: { latitude: 15.179384, longitude: 39.782334 },
  ee: { latitude: 58.595272, longitude: 25.013607 },
  et: { latitude: 9.145, longitude: 40.489673 },
  fk: { latitude: -51.796253, longitude: -59.523613 },
  fo: { latitude: 61.892635, longitude: -6.911806 },
  fj: { latitude: -16.578193, longitude: 179.414413 },
  fi: { latitude: 61.92411, longitude: 25.748151 },
  fr: { latitude: 46.603354, longitude: 1.888334 },
  gf: { latitude: 3.933889, longitude: -53.125782 },
  pf: { latitude: -17.679742, longitude: -149.406843 },
  ga: { latitude: -0.803689, longitude: 11.609444 },
  gm: { latitude: 13.443182, longitude: -15.310139 },
  ge: { latitude: 42.315407, longitude: 43.356892 },
  de: { latitude: 51.165691, longitude: 10.451526 },
  gh: { latitude: 7.946527, longitude: -1.023194 },
  gi: { latitude: 36.137741, longitude: -5.345374 },
  gr: { latitude: 39.074208, longitude: 21.824312 },
  gl: { latitude: 71.706936, longitude: -42.604303 },
  gd: { latitude: 12.262776, longitude: -61.604171 },
  gp: { latitude: 16.995971, longitude: -62.067641 },
  gu: { latitude: 13.444304, longitude: 144.793731 },
  gt: { latitude: 15.783471, longitude: -90.230759 },
  gg: { latitude: 49.465691, longitude: -2.585278 },
  gn: { latitude: 9.945587, longitude: -9.696645 },
  gw: { latitude: 11.803749, longitude: -15.180413 },
  gy: { latitude: 4.860416, longitude: -58.93018 },
  ht: { latitude: 18.971187, longitude: -72.285215 },
  hn: { latitude: 15.199999, longitude: -86.241905 },
  hk: { latitude: 22.396428, longitude: 114.109497 },
  hu: { latitude: 47.162494, longitude: 19.503304 },
  is: { latitude: 64.963051, longitude: -19.020835 },
  in: { latitude: 20.593684, longitude: 78.96288 },
  id: { latitude: -0.789275, longitude: 113.921327 },
  ir: { latitude: 32.427908, longitude: 53.688046 },
  iq: { latitude: 33.223191, longitude: 43.679291 },
  ie: { latitude: 53.41291, longitude: -8.24389 },
  im: { latitude: 54.236107, longitude: -4.548056 },
  il: { latitude: 31.046051, longitude: 34.851612 },
  it: { latitude: 41.87194, longitude: 12.56738 },
  ci: { latitude: 7.539989, longitude: -5.54708 },
  jm: { latitude: 18.109581, longitude: -77.297508 },
  jp: { latitude: 36.204824, longitude: 138.252924 },
  je: { latitude: 49.214439, longitude: -2.13125 },
  jo: { latitude: 30.585164, longitude: 36.238414 },
  kz: { latitude: 48.019573, longitude: 66.923684 },
  ke: { latitude: -0.023559, longitude: 37.906193 },
  ki: { latitude: -3.370417, longitude: -168.734039 },
  xk: { latitude: 42.602636, longitude: 20.902977 },
  kw: { latitude: 29.31166, longitude: 47.481766 },
  kg: { latitude: 41.20438, longitude: 74.766098 },
  la: { latitude: 19.85627, longitude: 102.495496 },
  lv: { latitude: 56.879635, longitude: 24.603189 },
  lb: { latitude: 33.854721, longitude: 35.862285 },
  ls: { latitude: -29.609988, longitude: 28.233608 },
  lr: { latitude: 6.428055, longitude: -9.429499 },
  ly: { latitude: 26.3351, longitude: 17.228331 },
  li: { latitude: 47.166, longitude: 9.555373 },
  lt: { latitude: 55.169438, longitude: 23.881275 },
  lu: { latitude: 49.815273, longitude: 6.129583 },
  mk: { latitude: 41.608635, longitude: 21.745275 },
  mg: { latitude: -18.766947, longitude: 46.869107 },
  mw: { latitude: -13.254308, longitude: 34.301525 },
  my: { latitude: 4.210484, longitude: 101.975766 },
  mv: { latitude: 3.202778, longitude: 73.22068 },
  ml: { latitude: 17.570692, longitude: -3.996166 },
  mt: { latitude: 35.937496, longitude: 14.375416 },
  mh: { latitude: 7.131474, longitude: 171.184478 },
  mq: { latitude: 14.641528, longitude: -61.024174 },
  mr: { latitude: 21.00789, longitude: -10.940835 },
  mu: { latitude: -20.348404, longitude: 57.552152 },
  yt: { latitude: -12.8275, longitude: 45.166244 },
  mx: { latitude: 23.634501, longitude: -102.552784 },
  fm: { latitude: 7.425554, longitude: 150.550812 },
  md: { latitude: 47.411631, longitude: 28.369885 },
  mc: { latitude: 43.750298, longitude: 7.412841 },
  mn: { latitude: 46.862496, longitude: 103.846656 },
  me: { latitude: 42.708678, longitude: 19.37439 },
  ms: { latitude: 16.742498, longitude: -62.187366 },
  ma: { latitude: 31.791702, longitude: -7.09262 },
  mz: { latitude: -18.665695, longitude: 35.529562 },
  mm: { latitude: 21.913965, longitude: 95.956223 },
  na: { latitude: -22.95764, longitude: 18.49041 },
  nr: { latitude: -0.522778, longitude: 166.931503 },
  np: { latitude: 28.394857, longitude: 84.124008 },
  nl: { latitude: 52.132633, longitude: 5.291266 },
  nc: { latitude: -20.904305, longitude: 165.618042 },
  nz: { latitude: -40.900557, longitude: 174.885971 },
  ni: { latitude: 12.865416, longitude: -85.207229 },
  ne: { latitude: 17.607789, longitude: 8.081666 },
  ng: { latitude: 9.081999, longitude: 8.675277 },
  nu: { latitude: -19.054445, longitude: -169.867233 },
  nf: { latitude: -29.040835, longitude: 167.954712 },
  kp: { latitude: 40.339852, longitude: 127.510093 },
  mp: { latitude: 17.33083, longitude: 145.38469 },
  no: { latitude: 60.472024, longitude: 8.468946 },
  om: { latitude: 21.512583, longitude: 55.923255 },
  pk: { latitude: 30.375321, longitude: 69.345116 },
  pw: { latitude: 7.51498, longitude: 134.58252 },
  ps: { latitude: 31.952162, longitude: 35.233154 },
  pa: { latitude: 8.537981, longitude: -80.782127 },
  pg: { latitude: -6.314993, longitude: 143.95555 },
  py: { latitude: -23.442503, longitude: -58.443832 },
  pe: { latitude: -9.189967, longitude: -75.015152 },
  ph: { latitude: 12.879721, longitude: 121.774017 },
  pn: { latitude: -24.703615, longitude: -127.439308 },
  pl: { latitude: 51.919438, longitude: 19.145136 },
  pt: { latitude: 39.399872, longitude: -8.224454 },
  pr: { latitude: 18.220833, longitude: -66.590149 },
  qa: { latitude: 25.354826, longitude: 51.183884 },
  re: { latitude: -21.115141, longitude: 55.536384 },
  ro: { latitude: 45.943161, longitude: 24.96676 },
  ru: { latitude: 61.52401, longitude: 105.318756 },
  rw: { latitude: -1.940278, longitude: 29.873888 },
  bl: { latitude: 17.900275, longitude: -62.833333 },
  sh: { latitude: -24.143474, longitude: -10.030696 },
  kn: { latitude: 17.357822, longitude: -62.782998 },
  lc: { latitude: 13.909444, longitude: -60.978893 },
  mf: { latitude: 18.070829, longitude: -63.050081 },
  pm: { latitude: 46.941936, longitude: -56.27111 },
  vc: { latitude: 12.984305, longitude: -61.287228 },
  ws: { latitude: -13.759029, longitude: -172.104629 },
  sm: { latitude: 43.94236, longitude: 12.457777 },
  st: { latitude: 0.18636, longitude: 6.613081 },
  sa: { latitude: 23.885942, longitude: 45.079162 },
  sn: { latitude: 14.497401, longitude: -14.452362 },
  rs: { latitude: 44.016521, longitude: 21.005859 },
  sc: { latitude: -4.679574, longitude: 55.491977 },
  sl: { latitude: 8.460555, longitude: -11.779889 },
  sg: { latitude: 1.352083, longitude: 103.819836 },
  sx: { latitude: 18.070829, longitude: -63.050081 },
  sk: { latitude: 48.669026, longitude: 19.699024 },
  si: { latitude: 46.151241, longitude: 14.995463 },
  sb: { latitude: -9.64571, longitude: 160.156194 },
  so: { latitude: 5.152149, longitude: 46.199616 },
  za: { latitude: -30.559482, longitude: 22.937506 },
  kr: { latitude: 35.907757, longitude: 127.766922 },
  es: { latitude: 40.463667, longitude: -3.74922 },
  lk: { latitude: 7.873054, longitude: 80.771797 },
  sd: { latitude: 12.862807, longitude: 30.217636 },
  sr: { latitude: 3.919305, longitude: -56.027783 },
  sj: { latitude: 77.553604, longitude: 23.670272 },
  sz: { latitude: -26.522503, longitude: 31.465866 },
  se: { latitude: 60.128161, longitude: 18.643501 },
  ch: { latitude: 46.818188, longitude: 8.227512 },
  sy: { latitude: 34.802075, longitude: 38.996815 },
  tw: { latitude: 23.69781, longitude: 120.960515 },
  tj: { latitude: 38.861034, longitude: 71.276093 },
  tz: { latitude: -6.369028, longitude: 34.888822 },
  th: { latitude: 15.870032, longitude: 100.992541 },
  tl: { latitude: -8.874217, longitude: 125.727539 },
  tg: { latitude: 8.619543, longitude: 0.824782 },
  tk: { latitude: -8.967363, longitude: -171.855881 },
  to: { latitude: -21.178986, longitude: -175.198242 },
  tt: { latitude: 10.691803, longitude: -61.222503 },
  tn: { latitude: 33.886917, longitude: 9.537499 },
  tr: { latitude: 38.963745, longitude: 35.243322 },
  tm: { latitude: 38.969719, longitude: 59.556278 },
  tc: { latitude: 21.694025, longitude: -71.797928 },
  tv: { latitude: -7.109535, longitude: 177.64933 },
  vi: { latitude: 18.335765, longitude: -64.896335 },
  ug: { latitude: 1.373333, longitude: 32.290275 },
  ua: { latitude: 48.379433, longitude: 31.16558 },
  ae: { latitude: 23.424076, longitude: 53.847818 },
  gb: { latitude: 55.378051, longitude: -3.435973 },
  us: { latitude: 37.09024, longitude: -95.712891 },
  uy: { latitude: -32.522779, longitude: -55.765835 },
  uz: { latitude: 41.377491, longitude: 64.585262 },
  vu: { latitude: -15.376706, longitude: 166.959158 },
  va: { latitude: 41.902916, longitude: 12.453389 },
  ve: { latitude: 6.42375, longitude: -66.58973 },
  vn: { latitude: 14.058324, longitude: 108.277199 },
  wf: { latitude: -13.768752, longitude: -177.156097 },
  eh: { latitude: 24.215527, longitude: -12.885834 },
  ye: { latitude: 15.552727, longitude: 48.516388 },
  zm: { latitude: -13.133897, longitude: 27.849332 },
  zw: { latitude: -19.015438, longitude: 29.154857 }
};
